import React from 'react';

/**
 * 国内航空券の当日予約で、検索結果の全便が受付時間を過ぎており
 * デフォルト選択できる便が1つもない場合に、旅程アウトラインの
 * 交通機関スロットに表示する青背景コールアウト（Figma node-id=493-49 準拠）。
 */
const SameDayReceptionClosedCallout: React.FC = () => {
  return (
    <div style={styles.container}>
      <p style={styles.heading}>受付時間を過ぎているため予約できません</p>
      <p style={styles.body}>国内航空券予約の受付は、営業時間内（9:00〜18:00）かつ出発の3時間前までです。</p>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#E9F2FB',
    display: 'flex' as const,
    flexDirection: 'column' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    textAlign: 'center' as const,
    padding: '40px 16px'
  },
  heading: {
    color: '#0080CB',
    fontWeight: 'bold' as const,
    fontSize: 12,
    margin: 0
  },
  body: {
    color: '#333333',
    fontSize: 11,
    marginTop: 8,
    marginBottom: 0
  }
};

export default SameDayReceptionClosedCallout;
